import app from 'firebase/app';
import { getUnsubscribedUsers } from './unsubscribed_users';

export const sendGridEmail = async data => {
    let unsubscribedUsers = [];
    await getUnsubscribedUsers()
        .then(items => {
            unsubscribedUsers = [...items].map(item => item.email);
            data.sendTo = data.sendTo.filter(
                recipient => !unsubscribedUsers.includes(recipient.email || recipient)
            );
        })
        .finally(() => {
            data = {
                ...data,
                originUrl: window.location.origin,
            };
        });

    const batchSize = 20;
    const sendgridMail = app.functions().httpsCallable('shareSendgridMail');

    async function sendBatchEmails(batch) {
        try {
            const result = await sendgridMail({ ...data, sendTo: batch });
            console.log('success sending', result);
        } catch (error) {
            console.log('error sending', error);
        }
    }

    for (let i = 0; i < data.sendTo.length; i += batchSize) {
        const batch = data.sendTo.slice(i, i + batchSize);
        await sendBatchEmails(batch);
    }
};

//function for confirm email after sign up
export const sendGridEmailAfterSignUp = async data => {
    let unsubscribedUsers = [];
    await getUnsubscribedUsers()
        .then(items => {
            unsubscribedUsers = [...items].map(item => item.email);
            data.sendTo = data.sendTo.filter(
                recipient => !unsubscribedUsers.includes(recipient.email)
            );
        })
        .finally(() => {
            data = {
                ...data,
                originUrl: window.location.origin,
            };
        });

    let sendgridMail = app.functions().httpsCallable('newUser');
    sendgridMail(data)
        .then(function (result) {
            console.log('success sending', result);
        })
        .catch(function (error) {
            console.log('error sending', error);
        });
};
